import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/portal/rport_desc.png'


const _withScopeId = n => (_pushScopeId("data-v-b09a79f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center report-title" }, "课堂教学行为AI评价报告", -1))
const _hoisted_2 = { class: "table" }
const _hoisted_3 = { class: "table-section table-section-0" }
const _hoisted_4 = { class: "table-tr table-tr-top" }
const _hoisted_5 = { class: "table-td" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "教师姓名", -1))
const _hoisted_7 = { class: "table-td" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "班级", -1))
const _hoisted_9 = { class: "table-td" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "学校", -1))
const _hoisted_11 = { class: "table-tr table-tr-bottom" }
const _hoisted_12 = { class: "table-td" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "课题", -1))
const _hoisted_14 = { class: "table-td" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "采样时间", -1))
const _hoisted_16 = { class: "table-td" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "分析用时", -1))
const _hoisted_18 = {
  class: "table-section table-section-1",
  style: {"height":"850px"}
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "report-title-3" }, "一、基于音频的基础数据分析", -1))
const _hoisted_20 = { class: "table-tr" }
const _hoisted_21 = { class: "table-td" }
const _hoisted_22 = { class: "table-td" }
const _hoisted_23 = { class: "table-tr" }
const _hoisted_24 = { class: "table-td" }
const _hoisted_25 = { class: "table-td" }
const _hoisted_26 = { class: "table-tr" }
const _hoisted_27 = { class: "table-td" }
const _hoisted_28 = { class: "table-td" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "table-box",
  style: {"height":"280px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "img-1 img-2" }, [
    /*#__PURE__*/_createElementVNode("div", {
      id: "myEcharts1",
      style: { width: '50%', height: '240px' }
    }),
    /*#__PURE__*/_createElementVNode("div", {
      id: "myEcharts2",
      style: { width: '50%', height: '240px' }
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "img-tips" }, "图1：基础数据分析")
], -1))
const _hoisted_30 = { class: "textarea-box" }
const _hoisted_31 = { class: "textarea-td" }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = { class: "table-section table-section-1 table-section-2" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "report-title-3" }, "二、基于RT和CH曲线分布的数据分析", -1))
const _hoisted_35 = { class: "table-tr" }
const _hoisted_36 = { class: "table-td" }
const _hoisted_37 = { class: "table-td" }
const _hoisted_38 = { class: "table-tr" }
const _hoisted_39 = { class: "table-td" }
const _hoisted_40 = { class: "table-td" }
const _hoisted_41 = { class: "table-box table-box-2" }
const _hoisted_42 = { class: "img-1" }
const _hoisted_43 = ["src"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img-tips" }, " 图2：RT数据分析(教师行为占时间率曲线分布)", -1))
const _hoisted_45 = { class: "table-box table-box-2" }
const _hoisted_46 = { class: "img-1" }
const _hoisted_47 = ["src"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img-tips" }, " 图3：CH数据分析(师生互动时间曲线分布)", -1))
const _hoisted_49 = { class: "table-box table-box-2" }
const _hoisted_50 = { class: "img-1" }
const _hoisted_51 = ["src"]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img-tips" }, "图4：教学行为数据分析", -1))
const _hoisted_53 = { class: "textarea-box" }
const _hoisted_54 = { class: "textarea-td" }
const _hoisted_55 = ["innerHTML"]
const _hoisted_56 = { class: "table-section table-section-1 table-section-3" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "report-title-3" }, "三、基于课堂类型的13分区图（RT-CH坐标图）", -1))
const _hoisted_58 = {
  class: "table-tr",
  style: {"margin-top":"20px"}
}
const _hoisted_59 = { class: "table-box" }
const _hoisted_60 = { class: "img-1" }
const _hoisted_61 = ["src"]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img-tips" }, "图5：RT-CH坐标图", -1))
const _hoisted_63 = {
  class: "type",
  style: {"height":"320px"}
}
const _hoisted_64 = ["innerHTML"]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "color-desc" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("i", {
      style: {"background":"#208c20"},
      class: "color"
    }),
    /*#__PURE__*/_createTextVNode(" 绿色为平衡 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("i", {
      style: {"background":"blue"},
      class: "color"
    }),
    /*#__PURE__*/_createTextVNode(" 蓝色为特色均衡 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("i", {
      style: {"background":"yellow"},
      class: "color"
    }),
    /*#__PURE__*/_createTextVNode(" 黄色为特色型 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("i", {
      style: {"background":"red"},
      class: "color"
    }),
    /*#__PURE__*/_createTextVNode(" 红色为失衡型 ")
  ])
], -1))
const _hoisted_66 = {
  class: "table-tr",
  style: {"margin-top":"20px"}
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "img-1" }, [
    /*#__PURE__*/_createElementVNode("div", {
      id: "myEcharts6",
      style: { width: '100%', height: '310px' }
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "img-tips" }, "图6：教学强度雷达图")
], -1))
const _hoisted_68 = {
  class: "",
  style: {"height":"320px"}
}
const _hoisted_69 = { class: "color-desc" }
const _hoisted_70 = { class: "textarea-box" }
const _hoisted_71 = { class: "textarea-td" }
const _hoisted_72 = ["innerHTML"]
const _hoisted_73 = { class: "textarea-box" }
const _hoisted_74 = { class: "textarea-td" }
const _hoisted_75 = ["innerHTML"]
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "table-section table-section-1 table-section-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "report-title-3" }, "备注：基于课堂类型的13分区图（RT-CH坐标图）的说明"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "table-tr",
    style: {"margin-top":"20px"}
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "table-box" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "img-1" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_0,
          class: "img-upload-6"
        })
      ])
    ])
  ])
], -1))
const _hoisted_77 = { class: "dialog-footer" }

import { reactive, ref, getCurrentInstance, computed, watch, onMounted, onUnmounted } from 'vue'
import type { FormInstance } from 'element-plus'
import htmlToPdf from '@/utils/htmlToPdf'

import * as echarts from 'echarts';
type EChartsOption = echarts.EChartsOption;



export default /*#__PURE__*/_defineComponent({
  __name: 'report',
  props: {
    visible: { type: Boolean, default: false },
    data: { default: {} }
  },
  emits: ['closed', 'confirm', 'update'],
  setup(__props: any, { emit }) {

const props = __props;

const { proxy } = getCurrentInstance()



const radioOptions = reactive([
  { name: '平衡型', code: 1 },
  { name: '均衡型', code: 2 },
  { name: '特色型', code: 3 },
  { name: '失衡型', code: 4 },
])

const reportForm = ref({
  audioTopic: '',
  audioId: '',
  analysisTime: '',
  classId: '',
  className: '',
  classNameN: '',
  sampleTime: '',
  schoolId: '',
  schoolName: '',
  teacherId: '',
  teacherName: '',
  studentNum: '',

  audioReportBaseAnalysis: {
    // 一、基于音频的基础数据分析
    teacherAct: '',
    conclusion: '',
    imgUrlList: [],
    studentAct: '',
    tmtime: '',
    tttime: '',
    tqtime: '',
    tltime: '',
  },

  audioReportRTAnalysis: {
    //二、基于RT和CH曲线分布的数据分析
    actUrl: '',
    chUrl: '',
    rtUrl: '',
    conclusion: '',
    dialogue: '',
    lecturing: '',
    question: '',
    selfLearning: '',
  },

  audioReport13Analysis: {
    //三、基于课堂类型的13分区图（RT
    adviseContent: '',
    analysisResult: '',
    interactStrength: '', //互动强度
    rtAndChUrl: '', //RT-CH坐标图，完成路径
    selfStudyStrength: '', //自习强度
    rtContent: '', //RT-CH坐标图内容
    strengthUrl: '', //教学强度雷达图，完成路径
    teachStrength: '', //讲授强度
  },
  radio: 1,
})
const reportRef = ref<FormInstance>()
const reportRules = {
  // audioTopic: [{ required: true, message: '请输入课题', trigger: 'blur' }],
  analysisTime: [
    { required: true, message: '请输入分析用时', trigger: 'blur' },
  ],

  audioReportBaseAnalysis: {
    tmtime: [
      { required: true, message: '请输入教师管理行为', trigger: 'blur' },
    ],
    tltime: [{ required: true, message: '请输入教师倾听', trigger: 'blur' }],
    tqtime: [{ required: true, message: '请输入教师提问', trigger: 'blur' }],
    tttime: [{ required: true, message: '请输入教师讲授', trigger: 'blur' }],
    teacherAct: [
      { required: true, message: '请输入教师行为', trigger: 'blur' },
    ],
    studentAct: [
      { required: true, message: '请输入学生行为', trigger: 'blur' },
    ],
    imgUrlList: [
      { required: true, message: '请上传基础数据分析', trigger: 'blur' },
    ],
    conclusion: [
      { required: true, message: '请输入基本结论', trigger: 'blur' },
    ],
  },

  audioReportRTAnalysis: {
    lecturing: [{ required: true, message: '请输入讲授', trigger: 'blur' }],
    selfLearning: [
      { required: true, message: '请输入自主学习', trigger: 'blur' },
    ],
    dialogue: [{ required: true, message: '请输入讨论', trigger: 'blur' }],
    question: [{ required: true, message: '请输入提问', trigger: 'blur' }],
    rtUrl: [{ required: true, message: '请上传RT数据分析', trigger: 'blur' }],
    chUrl: [{ required: true, message: '请上传CH数据分析', trigger: 'blur' }],
    actUrl: [
      { required: true, message: '请上传教学行为数据分析', trigger: 'blur' },
    ],
    conclusion: [
      { required: true, message: '请输入基本结论', trigger: 'blur' },
    ],
  },

  audioReport13Analysis: {
    rtAndChUrl: [
      { required: true, message: '请上传RT-CH坐标图', trigger: 'blur' },
    ],
    rtContent: [{ required: true, message: '请输入内容', trigger: 'blur' }],
    strengthUrl: [
      { required: true, message: '请上教学强度雷达图', trigger: 'blur' },
    ],
    selfStudyStrength: [
      { required: true, message: '请输入自习强度', trigger: 'blur' },
    ],
    interactStrength: [
      { required: true, message: '请输入互动强度', trigger: 'blur' },
    ],
    teachStrength: [
      { required: true, message: '请输入讲授强度', trigger: 'blur' },
    ],
    analysisResult: [
      { required: true, message: '请输入分析结果', trigger: 'blur' },
    ],
    adviseContent: [
      { required: true, message: '请输入评价建议', trigger: 'blur' },
    ],
  },
}



watch(
  () => props.data,
  (newV) => {
    if (newV) {
      reportForm.value = {
        ...reportForm.value,
        ...newV,
      }
      reportForm.value.audioId = newV.id
      reportForm.value.audioTopic = newV.topic
      reportForm.value.sampleTime = newV.classHour
      reportForm.value.className = newV.gradeList
        ? newV.gradeList[0].className
        : ''
      reportForm.value.classId = newV.gradeList ? newV.gradeList[0].classId : ''
      reportForm.value.classNameN = newV.gradeList
        ? newV.gradeList[0].gradeName + newV.gradeList[0].className
        : ''

      reportForm.value.audioReportBaseAnalysis.teacherAct = reportForm.value.audioReportBaseAnalysis.teacherAct.replace("%", "");
      reportForm.value.audioReportBaseAnalysis.studentAct = reportForm.value.audioReportBaseAnalysis.studentAct.replace("%", "");

    }
  },
  {
    immediate: true,
    deep: true,
  }


)


onMounted(() => {

  setTimeout(() => {

    let list1 = [
      {
        name: 'teacher ' + reportForm.value.audioReportBaseAnalysis.teacherAct + '%',
        value: reportForm.value.audioReportBaseAnalysis.teacherAct
      },
      {
        name: 'student ' + reportForm.value.audioReportBaseAnalysis.studentAct + '%',
        value: reportForm.value.audioReportBaseAnalysis.studentAct
      },
    ]
    let list2 = [
      {
        name: 'TM ' + getToFixed(reportForm.value.audioReportBaseAnalysis.tmtime) + '%',
        value: getToFixed(reportForm.value.audioReportBaseAnalysis.tmtime)
      },
      {
        name: 'TL ' + getToFixed(reportForm.value.audioReportBaseAnalysis.tltime) + '%',
        value: getToFixed(reportForm.value.audioReportBaseAnalysis.tltime)
      },
      {
        name: 'TQ ' + getToFixed(reportForm.value.audioReportBaseAnalysis.tqtime) + '%',
        value: getToFixed(reportForm.value.audioReportBaseAnalysis.tqtime)
      },
    ]

    let list6 = [
      reportForm.value.audioReport13Analysis.selfStudyStrength,
      reportForm.value.audioReport13Analysis.interactStrength,
      reportForm.value.audioReport13Analysis.teachStrength
    ]

    initChart(list1);
    initChart2(list2)
    initChart6(list6)
  }, 1)

})
onUnmounted(() => {
  echarts.dispose;
})


// 
const initChart = (dataList) => {
  let chart = echarts.init(document.getElementById("myEcharts1"), "drak");
  let option: EChartsOption;
  option = {
    color: ['#00a2e5', '#062d41', '#007baf'],
    series: [
      {
        // name: 'Access From',
        type: 'pie',
        radius: '40%',
        // data: [
        //   { value: 90, name: 'teacher 90%' },
        //   { value: 7.33, name: 'student 7.33%' },
        // ],
        data: dataList,
      }
    ]
  }
  // 把;配置和数据放这里
  option && chart.setOption(option);
  window.onresize = function () {
    chart.resize();
  }
}
const initChart2 = (dataList) => {
  let chart = echarts.init(document.getElementById("myEcharts2"), "drak");
  let option: EChartsOption;
  option = {
    color: ['#00a2e5', '#062d41', '#007baf'],
    series: [
      {
        // name: 'Access From',
        type: 'pie',
        radius: '40%',
        data: dataList,
      }
    ]
  }
  // 把;配置和数据放这里
  option && chart.setOption(option);
  window.onresize = function () {
    chart.resize();
  }
}

// 雷达图
const initChart6 = (dataList) => {
  let chart = echarts.init(document.getElementById("myEcharts6"), "drak");
  // let option: EChartsOption;
  let option = {
    backgroundColor: '#f6f6f6',
    color: ['#2d3f27', '#140983'],
    legend: {                        // 图例组件
      show: true,
      icon: 'rect',                   // 图例项的 icon。ECharts 提供的标记类型包括 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow'也可以通过 'image://url' 设置为图片，其中 url 为图片的链接，或者 dataURI。可以通过 'path://' 将图标设置为任意的矢量路径。         
      top: '10%',                    // 图例距离顶部边距
      right: '10%',                   // 图例距离左侧边距
      itemWidth: 10,                  // 图例标记的图形宽度。[ default: 25 ]
      itemHeight: 10,                 // 图例标记的图形高度。[ default: 14 ]
      itemGap: 6,                	// 图例每项之间的间隔。[ default: 10 ]横向布局时为水平间隔，纵向布局时为纵向间隔。
      orient: 'vertical',         // 图例列表的布局朝向,'horizontal'为横向,''为纵向.
      textStyle: {                    // 图例的公用文本样式。
        fontSize: 11,
        color: '#000',
      },
      backgroundColor: 'rgba(200,200,200,0.3)',
      data: [{                    // 图例的数据数组。数组项通常为一个字符串，每一项代表一个系列的 name（如果是饼图，也可以是饼图单个数据的 name）。图例组件会自动根据对应系列的图形标记（symbol）来绘制自己的颜色和标记，特殊字符串 ''（空字符串）或者 '\n'（换行字符串）用于图例的换行。
        name: '标准',                 // 图例项的名称，应等于某系列的name值（如果是饼图，也可以是饼图单个数据的 name）。                    
        icon: 'rect',               // 图例项的 icon。
        iconSize: 0,                // 图例项的图标大小，默认为 12 像素。
        textStyle: {                // 图例项的文本样式。
          // fontWeight: 'bold'		// 文字字体的粗细，可选'normal'，'bold'，'bolder'，'lighter'
        }
      }, {
        name: '本节课',
        icon: 'rect',
        iconSize: 6,                // 图例项的图标大小，默认为 12 像素。
        textStyle: {
          // fontWeight: 'bold'		// 文字字体的粗细，可选'normal'，'bold'，'bolder'，'lighter'
        }
      }],
    },

    radar: {
      center: ["50%", "55%"],
      radius: 130,                        // 圆的半径，数组的第一项是内半径，第二项是外半径。
      startAngle: 90,

      indicator: [
        { name: '自习强度', max: 600 },
        { name: '互动强度', max: 600 },
        { name: '讲授强度', max: 600 },
      ],
      name: {
        formatter: '{value}',
        textStyle: {
          color: '#000' // 文字颜色
        }
      },
      nameGap: 5,                        // 指示器名称和指示器轴的距离。[ default: 15 ]
      splitNumber: 6,                     // (这里是圆的环数)指示器轴的分割段数。[ default: 5 ]
      shape: 'circle',                   // 雷达图绘制类型，支持 'polygon'(多边形) 和 'circle'(圆)。[ default: 'polygon' ]

      axisLine: {                         // (圆内的几条直线)坐标轴轴线相关设置
        lineStyle: {
          color: '#fff',                   // 坐标轴线线的颜色。
          width: 1,                      	 // 坐标轴线线宽。
          type: 'solid',                   // 坐标轴线线的类型。
        }

      },
      splitLine: {                        // (这里是指所有圆环)坐标轴在 grid 区域中的分隔线。
        lineStyle: {
          color: '#fff',                       // 分隔线颜色
          width: 1, 							 // 分隔线线宽
        }
      },
      splitArea: {                        // 坐标轴在 grid 区域中的分隔区域，默认不显示。
        show: true,
        areaStyle: {                            // 分隔区域的样式设置。
          color: ['rgba(200,200,200,0.3)', 'rgba(200,200,200,0.3)'],       // 分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
        }
      },

    },
    series: [{
      type: 'radar',
      data: [
        {
          name: '标准',
          value: [60, 60, 60],
          // symbol: 'circle',
          symbolSize: 0,
        },
        {
          value: dataList,
          name: '本节课',
          symbolSize: 0,
          label: {
            normal: {
              show: true,
              formatter: function (params) {
                return params.value;
              }
            }
          }
        },



      ]
    }]

  }
  // 把;配置和数据放这里
  option && chart.setOption(option);
  window.onresize = function () {
    chart.resize();
  }
}

const getToFixed = (num) => {
  let total = Number(reportForm.value.audioReportBaseAnalysis.tmtime) +
    Number(reportForm.value.audioReportBaseAnalysis.tltime) +
    Number(reportForm.value.audioReportBaseAnalysis.tqtime)
  if (num && total) {
    return (num / total * 100).toFixed(2)

  } else {
    return 0
  }
}




const dialogShow = computed({
  get: () => props.visible,
  set: (val) => emit('update', val),
})

const handelClose = () => {
  if (loading.value) {
    return proxy.$msg.warning('生成报告中,请勿关闭!')
  } else {
    resetForm(reportRef.value)
  }
}

/**
 * 取消 重置表单
 */
const resetForm = (form: FormInstance | undefined) => {
  if (!form) return
  form.resetFields()
  emit('closed')
}

/**
 * 确定 提交
 */
const handleReportSubmit = async (formEl: FormInstance | undefined) => {
  console.log(reportForm.value)

  if (!formEl) return
  await formEl.validate(async (valid, fields) => {
    if (valid) {
      const { startDate, endDate, gradeLevel, count } = reportForm.value
      let params = {
        startDate,
        endDate,
        gradeLevel,
        count,
      }

      // const response = await reportApi(params)

      emit('confirm')
    } else {
      proxy.$msg.error('请填写完整信息')
    }
  })
}

// loading

const loading = ref(false)

const pdfFunc = () => {
  loading.value = true
  // 调用htmlToPdf工具函数
  htmlToPdf.getPdf('课堂教学行为AI评价报告', '#pdfDom',)
  setTimeout(() => {
    loading.value = false
    proxy.$msg.success('生成报告成功!')
  }, 3500)
}


return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "报告",
    modelValue: dialogShow.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogShow).value = $event)),
    "before-close": handelClose,
    "close-on-press-escape": false,
    "close-on-click-modal": false,
    "destroy-on-close": true,
    width: "860px",
    class: "dialog"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_77, [
        _createVNode(_component_el_button, {
          onClick: handelClose,
          round: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        (props.data.operat)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleReportSubmit(reportRef.value))),
              round: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 确定 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: pdfFunc,
          round: "",
          loading: loading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 下载报告 ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_scrollbar, { style: {"width":"100%","height":"800px","box-sizing":"border-box"} }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            id: "pdfDom",
            style: {"width":"100%","box-sizing":"border-box"},
            model: reportForm.value,
            ref_key: "reportRef",
            ref: reportRef,
            rules: reportRules,
            "label-width": "150",
            "label-position": "top",
            "hide-required-asterisk": true
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("section", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _hoisted_6,
                      _createElementVNode("div", null, _toDisplayString(reportForm.value.teacherName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("div", null, _toDisplayString(reportForm.value.classNameN) + " (" + _toDisplayString(reportForm.value.studentNum) + " 人)", 1)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("div", null, _toDisplayString(reportForm.value.schoolName), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("div", null, _toDisplayString(reportForm.value.audioTopic), 1)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("div", null, _toDisplayString(reportForm.value.sampleTime ? reportForm.value.sampleTime+'min':''), 1)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("div", null, _toDisplayString(reportForm.value.analysisTime), 1)
                    ])
                  ])
                ]),
                _createElementVNode("section", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, "TM time教师管理行为：" + _toDisplayString(reportForm.value.audioReportBaseAnalysis.tmtime + 's'), 1),
                    _createElementVNode("div", _hoisted_22, "TQ time 教师提问：" + _toDisplayString(reportForm.value.audioReportBaseAnalysis.tqtime + 's'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, "TL time 教师倾听：" + _toDisplayString(reportForm.value.audioReportBaseAnalysis.tltime + 's'), 1),
                    _createElementVNode("div", _hoisted_25, "TT time教师讲授：" + _toDisplayString(reportForm.value.audioReportBaseAnalysis.tttime + 's'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, "Teacher教师行为：" + _toDisplayString(reportForm.value.audioReportBaseAnalysis.teacherAct + '%'), 1),
                    _createElementVNode("div", _hoisted_28, "Student 学生行为：" + _toDisplayString(reportForm.value.audioReportBaseAnalysis.studentAct + '%'), 1)
                  ]),
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_el_form_item, {
                        label: "基本结论：",
                        prop: "audioReportBaseAnalysis.conclusion",
                        class: "label-bold"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            innerHTML: reportForm.value.audioReportBaseAnalysis.conclusion,
                            class: "textarea-html"
                          }, null, 8, _hoisted_32)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("section", _hoisted_33, [
                  _hoisted_34,
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, "Lecturing讲授：" + _toDisplayString('时长' + reportForm.value.audioReportRTAnalysis.lecturing + '分钟'), 1),
                    _createElementVNode("div", _hoisted_37, "Self-learning自主学习：" + _toDisplayString('时长' + reportForm.value.audioReportRTAnalysis.lecturing  + '分钟'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, "Dialogue讨论：" + _toDisplayString('频次'+ reportForm.value.audioReportRTAnalysis.lecturing +'次/课'), 1),
                    _createElementVNode("div", _hoisted_40, "Question 提问：" + _toDisplayString('频次'+ reportForm.value.audioReportRTAnalysis.lecturing +'次/课'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("img", {
                        src: reportForm.value.audioReportRTAnalysis.rtUrl,
                        alt: ""
                      }, null, 8, _hoisted_43)
                    ]),
                    _hoisted_44
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("img", {
                        src: reportForm.value.audioReportRTAnalysis.chUrl,
                        alt: ""
                      }, null, 8, _hoisted_47)
                    ]),
                    _hoisted_48
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("img", {
                        src: reportForm.value.audioReportRTAnalysis.actUrl,
                        alt: ""
                      }, null, 8, _hoisted_51)
                    ]),
                    _hoisted_52
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createVNode(_component_el_form_item, {
                        label: "基本结论：",
                        class: "label-bold"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            innerHTML: reportForm.value.audioReportRTAnalysis.conclusion,
                            class: "textarea-html"
                          }, null, 8, _hoisted_55)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("section", _hoisted_56, [
                  _hoisted_57,
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("img", {
                          style: {"max-height":"280px"},
                          src: reportForm.value.audioReport13Analysis.rtAndChUrl,
                          alt: ""
                        }, null, 8, _hoisted_61)
                      ]),
                      _hoisted_62
                    ]),
                    _createElementVNode("div", _hoisted_63, [
                      _createVNode(_component_el_form_item, { label: "类型：" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            style: {"font-size":"12px"},
                            innerHTML: reportForm.value.audioReport13Analysis.rtContent,
                            class: "textarea-html"
                          }, null, 8, _hoisted_64)
                        ]),
                        _: 1
                      }),
                      _hoisted_65
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _hoisted_67,
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("div", null, " 自习强度：" + _toDisplayString(reportForm.value.audioReport13Analysis.selfStudyStrength), 1),
                        _createElementVNode("div", null, " 互动强度：" + _toDisplayString(reportForm.value.audioReport13Analysis.interactStrength), 1),
                        _createElementVNode("div", null, " 讲授强度：" + _toDisplayString(reportForm.value.audioReport13Analysis.teachStrength), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("div", _hoisted_71, [
                      _createVNode(_component_el_form_item, {
                        label: "分析结果：",
                        class: "label-bold"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            innerHTML: reportForm.value.audioReport13Analysis.analysisResult,
                            class: "textarea-html"
                          }, null, 8, _hoisted_72)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("div", _hoisted_74, [
                      _createVNode(_component_el_form_item, {
                        label: "评价建议：",
                        class: "label-bold"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            innerHTML: reportForm.value.audioReport13Analysis.adviseContent,
                            class: "textarea-html"
                          }, null, 8, _hoisted_75)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _hoisted_76
              ])
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})